import "./styles.css";
import {
  Card,
  Row,
  Col,
  Space,
  Typography,
  Divider,
  Button,
  message,
  Modal,
  Form,
  Input,
  Select,
  Tag,
  Upload,
  List,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined, FileTextOutlined } from "@ant-design/icons";
import { changeCurriculoUsuario, getCurriculoUsuario } from "../../api/curriculoUsuario";
import { getEstados } from "../../api/estados";
import { validatePhone } from "../../helpers/validators";
import { getMunicipios } from "../../api/municipios";
import { getSexos } from "../../api/sexos";
import { addAnexo, deleteAnexos, getAnexos, getAnexoDocumento } from "../../api/anexos";
import { configModal } from "../modalConfig/config";
import { useAuth } from "../../contexts/AuthContext";
import { HomeImagem } from "../homeImagem";
import dayjs from "dayjs";
import InputMask from "../inputMask";
import { maskCpf } from "../../helpers/masks";
const { Text, Title, Link } = Typography;

const styles = {
  marginBlock: {
    marginBlock: 10,
  },
  padding: {
    paddingInline: 5,
  },
};

const options_pcd = [
  { value: 1, label: "Sim" },
  { value: 0, label: "Não" },
];

const validator = {
  nome: [{ required: true, message: "Informe o nome completo!" }],
  id_cad_municipios: [{ required: true, message: "Selecione o município!" }],
  id_cad_estados: [{ required: true, message: "Selecione o estado!" }],
  id_cad_sexos: [{ required: true, message: "Selecione uma opção!" }],
  pcd: [{ required: true, message: "Selecione uma opção!" }],
  celular: [
    { required: true, message: "Informe o celular!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validatePhone(getFieldValue("celular"))) {
          return Promise.resolve();
        }
        return Promise.reject("Informe um celular válido!");
      },
    }),
  ],
  email: [
    {
      type: "email",
      message: "Informe um e-mail válido!",
    },
  ],
};

const HomeCadastro = () => {
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [sexos, setSexos] = useState([]);
  const [anexos, setAnexos] = useState([]);
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const { atualizarDados, encerrarSessao } = useAuth();

  useEffect(() => {
    carregarCurriculoUsuario();
    listarEstados();
    listarSexos();
    listarAnexos();
  }, []);

  const carregarCurriculoUsuario = async () => {
    setLoading(true);
    try {
      const retorno = await getCurriculoUsuario();
      if (retorno?.statusCode === 200) {
        setDados(retorno?.response?.data);
        atualizarDados(retorno?.response?.data);
      } else if (retorno?.statusCode === 401) {
        message.error(retorno?.response?.message);
        await encerrarSessao();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarEstados = async () => {
    setLoading(true);
    try {
      const retorno = await getEstados();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_estados = [];
        for (let index = 0; index < data?.length; index++) {
          array_estados.push({ value: data?.[index]?.uf, label: data?.[index]?.descricao });
        }
        setEstados(array_estados);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarSexos = async () => {
    setLoading(true);
    try {
      const retorno = await getSexos();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_sexos = [];
        for (let index = 0; index < data?.length; index++) {
          array_sexos.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }
        setSexos(array_sexos);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarMunicipios = async (uf) => {
    setLoading(true);
    try {
      const retorno = await getMunicipios(uf);
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_municipios = [];
        for (let index = 0; index < data?.length; index++) {
          array_municipios.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }

        setMunicipios(array_municipios);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const Item = ({ title, description }) => {
    return (
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={12}
        xl={12}
        xxl={12}
        align="left"
        style={{ ...styles?.marginBlock, ...styles?.padding }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary">{title}</Text>
          <Text>{description}</Text>
        </Space>
      </Col>
    );
  };

  const onSubmit = (formulario) => {
    alterar({
      nome: formulario?.nome,
      id_cad_estados: formulario?.uf,
      id_cad_municipios: formulario?.id_cad_municipios,
      celular: formulario?.celular?.replace(/[^\d]+/g, ""),
      email: formulario?.email,
      pcd: formulario?.pcd,
      id_cad_sexos: formulario?.id_cad_sexos,
    });
  };

  const handleChangeEstado = (value) => {
    form?.setFieldsValue({ id_cad_municipios: undefined });
    listarMunicipios(value);
  };

  const alterar = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await changeCurriculoUsuario(formulario);
      if (retorno?.statusCode === 200) {
        message.success("Dados alterados com sucesso!");
        setShowModal(false);
        form?.resetFields();
        carregarCurriculoUsuario();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const adicionarAnexo = async (file) => {
    setLoading(true);

    const formato =
      file?.type === "application/pdf" ||
      file?.type === "application/msword" ||
      file?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    if (!formato) {
      message.error("Selecione um documento PDF, DOC ou DOCX!");
      setLoading(false);
      return;
    }
    const size = file?.size / 1024 / 1024 > 20;
    if (size) {
      message.error("Tamanho não suportado, máximo 20MB!");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file ?? "");

    try {
      const retorno = await addAnexo(formData);
      if (retorno?.statusCode === 200) {
        message.success("Registro inserido com sucesso!");
        listarAnexos();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const handleOpenModal = (data) => {
    setShowModal(true);
    form.setFieldsValue({
      nome: data?.nome,
      id_cad_estados: data?.uf,
      id_cad_municipios: data?.id_cad_municipios,
      celular: data?.celular,
      email: data?.email,
      pcd: data?.pcd ?? null,
      id_cad_sexos: data?.id_cad_sexos ?? null,
    });

    listarMunicipios(data?.uf);
  };

  const carregarAnexo = async (id, nome) => {
    setLoading(true);
    try {
      const retorno = await getAnexoDocumento(id);
      if (retorno?.statusCode === 200) {
        const url = window.URL.createObjectURL(retorno?.response?.data);
        let a = document.createElement("a");
        a.href = url;
        a.download = nome ?? "documento.pdf";
        a.setAttribute("download", nome ?? "documento.pdf");
        a.click();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text className="title-middle">
            <EditOutlined /> Editar
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          form?.resetFields();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="nome" label="Nome" hasFeedback rules={validator?.nome}>
                <Input size="large" placeholder="Informe o nome completo" disabled={loading} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_estados" label="Estado" hasFeedback rules={validator?.id_cad_estados}>
                <Select
                  size="large"
                  placeholder="Selecione o estado"
                  options={estados}
                  disabled={loading}
                  onChange={handleChangeEstado}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_municipios" label="Município" hasFeedback rules={validator?.id_cad_municipios}>
                <Select
                  size="large"
                  placeholder="Selecione o município"
                  options={municipios}
                  disabled={loading}
                  showSearch
                  filterOption={(input, option) => (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="celular" label="Celular" hasFeedback rules={validator?.celular}>
                <InputMask mask="(99) 9 9999-9999" size="large" placeholder="Informe o celular" disabled={loading} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="email" label="E-mail (Opcional)" hasFeedback rules={validator?.email}>
                <Input size="large" placeholder="Informe o e-mail" disabled={loading} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="pcd" label="PCD (Pessoa Com Deficiência)" hasFeedback rules={validator?.pcd}>
                <Select size="large" placeholder="Selecione uma opção" options={options_pcd} disabled={loading} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_sexos" label="Sexo" hasFeedback rules={validator?.id_cad_sexos}>
                <Select size="large" placeholder="Selecione uma opção" options={sexos} disabled={loading} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  const deletarAnexo = async (id) => {
    setLoading(true);
    try {
      const retorno = await deleteAnexos(id);
      if (retorno?.statusCode === 200) {
        message.success("Registro excluído com sucesso!");
        listarAnexos();
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const listarAnexos = async () => {
    setLoading(true);
    try {
      const retorno = await getAnexos();
      if (retorno?.statusCode === 200) {
        setAnexos(retorno?.response?.data);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const formAnexos = () => {
    return (
      <Upload.Dragger
        disabled={loading}
        beforeUpload={() => false}
        onChange={(e) => adicionarAnexo(e?.file)}
        accept=".pdf, .doc, .docx"
        maxCount={1}
        fileList={[]}
        multiple={false}>
        <p className="ant-upload-drag-icon">
          <FileTextOutlined />
        </p>
        <p className="ant-upload-text">Adicione aqui o seu currículo (PDF, DOC, DOCX)</p>
        <p className="ant-upload-hint">Clique ou arraste para enviar o arquivo</p>
      </Upload.Dragger>
    );
  };

  const renderAnexos = (data) => {
    return (
      <List
        loading={loading}
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={<FileTextOutlined className="title" />}
              title={<Link onClick={() => carregarAnexo(item?.id, item?.nome)}>Currículo Documento</Link>}
              description={<Text type="secondary">{item?.nome}</Text>}
            />
            <Button
              size="large"
              danger
              type="text"
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() =>
                modal.confirm({
                  ...configModal,
                  title: "Atenção",
                  content: "Deseja deletar este registro?",
                  onOk() {
                    deletarAnexo(item?.id);
                  },
                })
              }
            />
          </List.Item>
        )}
      />
    );
  };

  return (
    <Card className="shadow">
      {modalFormulario()}
      <Row>
        <Col xs={24} sm={10} md={10} lg={10} xl={10} xxl={8} align="left" style={styles?.marginBlock}>
          <div className="image-container">
            <HomeImagem id={dados?.id} loadingComponent={loading} />
          </div>
        </Col>

        <Col xs={24} sm={14} md={14} lg={14} xl={14} xxl={16} align="left" style={styles?.marginBlock}>
          <Title className="title">{dados?.nome ?? "-"}</Title>
          <Divider style={styles?.marginBlock} />
          <Row>
            <Item title="Nascimento" description={dayjs(dados?.data_nascimento).format("DD/MM/YYYY") ?? "-"} />
            <Item title="CPF" description={maskCpf(dados?.cpf?.toString()?.padStart(11, "0")) ?? "-"} />
            <Item title="Genêro" description={dados?.sexo ? dados?.sexo : "-"} />
            <Item title="E-mail" description={dados?.email ? dados?.email : "-"} />
            <Item title="Celular" description={dados?.celular ? dados?.celular : "-"} />
            <Item
              title="Localização"
              description={`${dados?.cidade ? dados?.cidade : ""} - ${dados?.uf ? dados?.uf : ""}`}
            />
            {dados?.pcd === 1 && (
              <Tag color="#fb9a54">
                <Text strong className="text-white">
                  PCD
                </Text>
              </Tag>
            )}
          </Row>
        </Col>

        <Col span={24} align="left" style={styles?.marginBlock}>
          <Button
            loading={loading}
            icon={<EditOutlined />}
            size="large"
            type="dashed"
            block
            onClick={() => handleOpenModal(dados)}>
            Editar
          </Button>
        </Col>

        <Col span={24} align="left">
          <Space className="full-width" direction="vertical">
            {anexos?.length > 0 ? renderAnexos(anexos) : formAnexos()}
          </Space>
        </Col>
      </Row>

      {contextHolder}
    </Card>
  );
};

export { HomeCadastro };
